import { Component, OnDestroy, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { navItems } from '../../_nav';
import { ApplicationConstants } from '../../common/constants'
import { AuthUserService } from '../../core/services/auth-service/auth-user.service';


@Component({
  selector: 'app-dashboard',
  templateUrl: './default-layout.component.html'
})
export class DefaultLayoutComponent implements OnDestroy {
  public navItems = navItems;
  public sidebarMinimized = true;
  private changes: MutationObserver;
  public element: HTMLElement;
  public appConst = ApplicationConstants;

  constructor(@Inject(AuthUserService) private userService,
    @Inject(DOCUMENT) _document?: any, ) {

    this.changes = new MutationObserver((mutations) => {
      this.sidebarMinimized = _document.body.classList.contains('sidebar-minimized');
    });
    this.element = _document.body;
    this.changes.observe(<Element>this.element, {
      attributes: true,
      attributeFilter: ['class']
    });
  }

  logout() {
    console.log("logout")
    this.userService.logout();
  }
  ngOnDestroy(): void {
    this.changes.disconnect();
  }
}
